import { Tooltip, Typography } from '@mui/material'
import { FC, useEffect, useRef, useState } from 'react'

interface TitleWithTooltipProps {
  title: string
}

export const TitleWithTooltip: FC<TitleWithTooltipProps> = ({ title }) => {
  const titleRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const element = titleRef.current
    if (!element) return

    const checkTruncation = () => {
      setIsTruncated(element.scrollWidth > element.clientWidth)
    }

    checkTruncation()
    const observer = new ResizeObserver(checkTruncation)
    observer.observe(element)
    return () => observer.disconnect()
  }, [title])

  return (
    <Tooltip title={title} placement="top-start" enterDelay={300} disableHoverListener={!isTruncated}>
      <Typography
        ref={titleRef}
        component="span"
        variant="body2"
        fontWeight={700}
        noWrap
        sx={{
          display: 'block',
          width: '100%',
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {title}
      </Typography>
    </Tooltip>
  )
}
